import React, { Component } from 'react';

class Banner extends Component {
    render() {
        return (
            <section className="banner" id='Banner'>
                <div className="banner-area">
                    <div className="container">
                        <div className="section-wrapper banner-wrapper">
                            <div className="row align-items-center">
                                <div className="col-lg-6 col-12">
                                    <div className="banner-content text-start">
                                        <h1>Hello...</h1>
                                        <h1>I'm <span>Emma</span> Grant A Professional</h1>
                                        <div className="dynamic-title cd-headline clip is-full-width">
                                            <h1 className="cd-words-wrapper">
                                                <b className="is-visible gold-title">Freelancer</b>
                                                <b className="gold-title">UX Designer</b>
                                                <b className="gold-title">Web Developer</b>
                                                <b className="gold-title">Web Designer</b>
                                            </h1>
                                        </div>
                                        <a className="btn" href="#"><span>View My Portfolio</span><img src="assets/images/icon/btn-1.png" alt="icon" className="img-fluid" /></a>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-12">
                                    <div className="banner-thumb">
                                        <img src="assets/images/banner/02.png" alt="banner" className="img-fluid" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Banner;